<template>
    <div>
        <ly-dialog ref="lyDialog" :fullScreenBodyPadding="0" v-model="dialogVisible" :title="loadingTitle" :before-close="handleBeforeClose" :fullscreen="true" :showFullscreen="false">
            <template v-slot:headerCenter="slotProps">
                <div class="lybuzhou">
                    <div></div>
                    <el-steps :active="currentActive" simple align-center style="width:470px">
                        <el-step title="基础信息" icon="InfoFilled" @click="handleStepClick(1)" :status="currentActive==1?'finish':'wait'" style="cursor: pointer;"/>
                        <el-step title="流程设计" icon="Connection" @click="handleStepClick(2)" :status="currentActive==2?'finish':'wait'" style="cursor: pointer;"/>
                        <el-step title="表单设计" icon="Cpu" @click="handleStepClick(3)" :status="currentActive==3?'finish':'wait'" style="cursor: pointer;"/>
                    </el-steps>
                    <el-button type="primary" @click="submitData" :loading="loadingSave" round>保存</el-button>
                </div>
            </template>
            <el-form :inline="false" :model="formData" :rules="rules" ref="rulesForm" label-position="right" label-width="auto" v-show="currentActive==1" style="width:50%;margin: 0 auto;padding-top: 20px;">
                <el-form-item label="流程名称：" prop="name">
                    <el-input v-model="formData.name" placeholder="请输入流程名称"></el-input>
                </el-form-item>
                <el-form-item label="版本：" prop="version">
                    <el-input v-model="formData.version" placeholder="请输入流程版本"></el-input>
                </el-form-item>
                <el-form-item label="流程说明：" prop="remark">
                    <el-input v-model="formData.remark" :rows="2" type="textarea" placeholder="请输入流程说明"/>
                </el-form-item>
                <el-form-item label="状态：" prop="status">
                    <el-switch
                        :active-value="1"
                        :inactive-value="0"
                        v-model="formData.status"
                        active-color="#13ce66"
                        inactive-color="#ff4949">
                    </el-switch>
                </el-form-item>
            </el-form>
            <LyWorkflow ref="lyworkflow" v-model="formData.nodeConfig" v-show="currentActive==2" :height.sync="designBodyHeight" :workflowConfig="workflowConfig"></LyWorkflow>
            <LyFormBuilder ref="lyformBuilder" :formJson="formData.formJson" v-show="currentActive==3" :height.sync="designBodyHeight" :builderConfig="builderConfig"></LyFormBuilder>
            <!-- <template #footer>
                <el-button @click="handleClose" :loading="loadingSave">取消</el-button>
                <el-button type="primary" @click="submitData" :loading="loadingSave">确定</el-button>
            </template> -->
        </ly-dialog>
    </div>
</template>

<script>
    import {lyworkflowAdd,lyworkflowEdit} from "@/api/api";
    import LyDialog from "@/components/dialog/dialog";
    import { deepClone,getDefaultWorkflowConfig,buildDefaultFormJson,isEmpty } from "@/utils/util";
    import LyWorkflow from '@/components/lyworkflow/index'
    import LyFormBuilder from '@/components/lyform-builder/lyFormBuilder'
    export default {
        name: "moduleWorkflow",
        components: {LyDialog,LyWorkflow,LyFormBuilder},
        emits: ['refreshData', 'closed'],
        data() {
            return {
                dialogVisible:false,
                loadingSave:false,
                loadingTitle:'',
                currentActive:1,
                designBodyHeight:"500px",
                formData:{
                    name:'',
                    remark:'',
                    version:"1.0",
                    status:1,
                    nodeConfig:getDefaultWorkflowConfig(),
                    formJson:buildDefaultFormJson()
                },
                workflowConfig:{
                    showHeader:true,//是否显示头部信息
                    showClearButton:true,//是否显示清空按钮
                    showDocumentButton:true,//是否显示文档按钮
                    exportJsonButton: true,  //是否显示导出JSON器按钮
                    importJsonButton:true, //是否显示导入代码按钮
                    showFullButton: true,  //是否显示全屏按钮
                    openNewWindowButton: false,  //是否显示新窗口按钮
                    showSaveImgButton:true,//是否显示保存图片按钮
                },
                builderConfig:{
                    showHeader:true,//是否显示头部信息
                    showFormTemplates:true,//是否显示表单模板
                    showEventCollapse:true,//是否显示组件事件属性折叠面板
                    showDocumentButton:true,//是否显示文档按钮
                    clearDesignerButton: true,  //是否显示清空设计器按钮
                    previewFormButton: true,  //是否显示预览表单按钮
                    exportJsonButton: true,  //是否显示导出JSON器按钮
                    exportCodeButton: false,  //是否显示导出代码按钮
                    importJsonButton:true, //是否显示导入代码按钮
                    showFullButton: true,  //是否显示全屏按钮
                    openNewWindowButton: false,  //是否显示新窗口按钮
                    saveFormButton:false,//是否显示保存表单按钮
                    showCrudSettings:false,//是否显示组件和表单的crud属性配置
                    showDesignAlert:false,//是否显示设计框内的alert信息提示
                },
                rules:{
                    name: [
                        {required: true, message: '请输入流程名称',trigger: 'blur'}
                    ],
                    version: [
                        {required: true, message: '请输入流程版本',trigger: 'blur'}
                    ],
                },
            }
        },
        methods:{
            handleBeforeClose() {
                this.$confirm('确定要关闭吗？',"警告",{
                closeOnClickModal:false,
                type:"warning"
            }).then(() => {
                    this.$emit('closed')
                })
                .catch(() => {
                // catch error
                })
            },
            handleClose() {
                this.$emit('closed')
            },
            handleOpen(item,flag) {
                this.loadingTitle=flag
                this.dialogVisible=true
                if(item){
                    this.formData = deepClone(item)
                    if(isEmpty(this.formData.formJson)){
                        this.formData.formJson = buildDefaultFormJson()
                    }
                }
            },
            handleStepClick(nums) {
                if(nums == 2 || nums == 3){
                    this.calcDesignBodyHeight()
                }
                this.currentActive = nums
            },
            submitData() {
                this.$refs['rulesForm'].validate(valid=>{
                    if(valid) {
                        this.loadingSave=true
                        let param = {
                            ...this.formData
                        }
                        if(this.formData.id){
                            lyworkflowEdit(param).then(res=>{
                                this.loadingSave=false
                                if(res.code ==2000) {
                                    this.$message.success(res.msg)
                                    this.dialogVisible = false;
                                    this.handleClose()
                                    this.$emit('refreshData')
                                } else {
                                    this.$message.warning(res.msg)
                                }
                            })
                        }else{
                            lyworkflowAdd(param).then(res=>{
                                this.loadingSave=false
                                if(res.code ==2000) {
                                    this.$message.success(res.msg)
                                    this.handleClose()
                                    this.$emit('refreshData')
                                } else {
                                    this.$message.warning(res.msg)
                                }
                            })
                        }

                    }else {
                        // 校验失败，聚焦到 rulesForm 表单
                        this.focusForm('rulesForm');
                    }
                })
            },
            focusForm(formRef) {
                // 聚焦到指定的表单
                this.$nextTick(() => {
                    this.currentActive = 1
                });
            },
            calcDesignBodyHeight(){
                const headerel = this.$refs.lyDialog.$el.querySelector('.el-dialog__header');
                const footerel = this.$refs.lyDialog.$el.querySelector('.el-dialog__footer');
                const headerHeight = headerel?headerel.offsetHeight:0
                const footerHeight = footerel?footerel.offsetHeight:0
                const tempheight = window.innerHeight - headerHeight - footerHeight
                // if (tempheight>200){
                    // this.designBodyHeight = (tempheight - 40)+'px' //全屏body内有padding值
                    this.designBodyHeight = (tempheight)+'px'
                // }
            },
            // 计算搜索栏的高度
            listenResize() {
                this.$nextTick(() => {
                    // setTimeout(() => {
                        this.calcDesignBodyHeight()
                    // }, 50);
                })
            }
        },
        mounted() {
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.listenResize()
        },
        unmounted() {
              // 页面销毁，去掉监听事件
			window.removeEventListener("resize", this.listenResize);
        },
    }
</script>
<style scoped>
.lybuzhou{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
</style>

